import React from "react";
import { QuickStatusDot } from "./QuickStatusDot.jsx";

const DEFAULT_TONES = ["blue", "yellow", "green", "red", "neutral"];

/**
 * Inline legend bar per inline-status-legend-contract.
 * @param {object} props
 * @param {string} props.legendId
 * @param {string} props.relatedModule
 * @param {string} [props.placement]
 * @param {Array<{ key: string, shortLabel?: string, fullLabel?: string }>} [props.tones]
 * @param {Record<string, string>} [props.shortLabels]
 * @param {Record<string, string>} [props.fullLabels]
 * @param {string} props.ariaLabel
 * @param {string} [props.testId]
 */
export function InlineStatusLegend({
  legendId,
  relatedModule,
  placement = "moduleBodyTop",
  tones,
  shortLabels = {},
  fullLabels = {},
  ariaLabel,
  testId,
}) {
  if (placement === "pageBottom" || placement === "standaloneCard" || placement === "headerLinkOnly") {
    return null;
  }

  const items =
    tones ||
    DEFAULT_TONES.map((key) => ({
      key,
      shortLabel: shortLabels[key] || key,
      fullLabel: fullLabels[key] || shortLabels[key] || key,
    }));

  return (
    <div
      className="cq-inline-status-legend"
      data-legend-id={legendId}
      data-related-module={relatedModule}
      data-placement={placement}
      data-testid={testId || legendId}
      role="group"
      aria-label={ariaLabel}
    >
      {items.map((item) => (
        <span key={item.key} className="cq-inline-status-legend__item">
          <QuickStatusDot
            statusTone={item.key}
            statusKey={item.key}
            label={item.shortLabel || item.key}
            accessibleLabel={item.fullLabel || item.shortLabel || item.key}
            size="sm"
            testId={`${legendId}-${item.key}`}
          />
          <span>{item.shortLabel || item.key}</span>
        </span>
      ))}
    </div>
  );
}
